import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/T.png';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 antialiased">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-md">
            <img src={logo} alt="Truyon Logo" className="w-8 h-8 object-contain" />
            <span className="text-xl font-bold tracking-tight text-gray-900">truyon</span>
          </Link>
          <Link 
            to="/" 
            className="text-indigo-600 hover:text-indigo-700 font-medium text-sm flex items-center gap-1 transition-colors focus:outline-none focus:underline"
          >
            &larr; Back to Home
          </Link>
        </div>
      </header>

      {/* Main Container */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
          
          {/* Hero Section */}
          <section className="bg-slate-900 px-6 sm:px-12 py-12 sm:py-16 text-center text-white relative">
            <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-indigo-500/20 text-indigo-300 border border-indigo-500/30 mb-4 tracking-wide uppercase">
              Next-Gen EdTech ERP
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white">
              Digitizing Education, Empowering Institutions
            </h1>
            <p className="text-slate-300 mt-4 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
              A cloud-native, multi-tenant ERP platform engineered to streamline the complete student lifecycle across colleges and multi-campus networks.
            </p>
          </section>

          {/* Company Overview */}
          <section className="px-6 sm:px-12 py-10 border-b border-gray-100">
            <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-2">Who We Are</h2>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Transforming Higher Education Operations</h3>
            <p className="text-gray-600 leading-relaxed text-base">
              At <strong className="text-gray-900 font-semibold">TRUYON TECHNOLOGIES (OPC) PVT LTD</strong>, we believe that managing an educational institution should not be constrained by legacy software, fragmented registers, or complex server infrastructure.
            </p>
            <p className="text-gray-600 leading-relaxed text-base mt-3">
              We are a dedicated Indian ed-tech enterprise providing accessible, modern, and cloud-native digitization for higher education institutions across India. Built specifically for individual colleges as well as multi-campus networks, Truyon consolidates administrative workflows into a single, unified digital core.
            </p>
          </section>

          {/* Key Advantages Highlights */}
          <section className="px-6 sm:px-12 py-10 border-b border-gray-100 bg-slate-50/50">
            <div className="mb-8">
              <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-2">Core Advantages</h2>
              <h3 className="text-2xl font-bold text-gray-900">Why Institutions Choose Truyon ERP</h3>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-gray-300 transition-colors">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center font-bold text-sm mb-4">
                  70%
                </div>
                <h4 className="font-bold text-gray-900 text-lg">Substantial Cost Advantage</h4>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                  Enterprise-grade campus management functionality delivered at approximately 70% lower total cost compared to traditional market alternatives.
                </p>
              </div>

              <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-gray-300 transition-colors">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center mb-4">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 001-9.999 5.002 5.002 0 00-9.78 2.096A4.001 4.001 0 003 15z" />
                  </svg>
                </div>
                <h4 className="font-bold text-gray-900 text-lg">Zero Infrastructure Overhead</h4>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                  Fully cloud-native multi-tenant architecture eliminates the need for local server hardware, database administration, or dedicated IT maintenance staff.
                </p>
              </div>

              <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-gray-300 transition-colors">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center mb-4">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h4 className="font-bold text-gray-900 text-lg">Intuitive User Interface</h4>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                  Modern, responsive UI/UX engineered for rapid adoption across administrative staff, faculty, students, and parents with minimal onboarding effort.
                </p>
              </div>

              <div className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm hover:border-gray-300 transition-colors">
                <div className="w-10 h-10 rounded-lg bg-indigo-50 border border-indigo-100 text-indigo-600 flex items-center justify-center mb-4">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <h4 className="font-bold text-gray-900 text-lg">Role-Based Access Control</h4>
                <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                  Granular security permissions tailored specifically for Administrators, HODs, Principals, Faculty, Clerks, Students, and Parents.
                </p>
              </div>
            </div>
          </section>

          {/* Mission & Vision */}
          <section className="px-6 sm:px-12 py-10 border-b border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="p-6 bg-slate-50 rounded-xl border border-slate-200/80">
                <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-2">Our Mission</h2>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Democratizing Campus Technology</h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  To empower educational institutions across India with high-performance, affordable, and zero-maintenance technology that reduces operational friction and elevates administrative efficiency.
                </p>
              </div>

              <div className="p-6 bg-slate-50 rounded-xl border border-slate-200/80">
                <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-2">Our Vision</h2>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Scaling Digital Transformation</h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  To digitally transform at least <strong className="text-gray-900 font-semibold">1,000 educational institutions</strong> across India, enabling administrators and faculty to focus on core academic goals.
                </p>
              </div>
            </div>
          </section>

          {/* Core Modules */}
          <section className="px-6 sm:px-12 py-10 border-b border-gray-100">
            <div className="mb-6">
              <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-2">Platform Capabilities</h2>
              <h3 className="text-2xl font-bold text-gray-900">Comprehensive Operational Modules</h3>
            </div>

            <div className="space-y-6">
              {/* Module 1 */}
              <div className="p-6 rounded-xl border border-gray-200 bg-white shadow-xs">
                <h4 className="text-lg font-bold text-gray-900 mb-2">
                  1. Complete Student Lifecycle Management
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  Centralized record-keeping and tracking from initial enrollment through daily academic performance to graduation:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-600">
                  <div className="p-3 bg-slate-50 rounded-lg">
                    <strong className="block text-gray-900 mb-1">Central Profiles</strong>
                    Unified repositories for personal, academic, guardian, and document records.
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg">
                    <strong className="block text-gray-900 mb-1">Attendance Engine</strong>
                    Real-time subject-wise logging with automated absenteeism alert systems.
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg">
                    <strong className="block text-gray-900 mb-1">Conduct & Leave</strong>
                    Structured administrative workflows for leave applications and records.
                  </div>
                </div>
              </div>

              {/* Module 2 */}
              <div className="p-6 rounded-xl border border-gray-200 bg-white shadow-xs">
                <h4 className="text-lg font-bold text-gray-900 mb-2">
                  2. Academic Operations & Examination Management
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">
                  Automated scheduling and evaluation workflows designed for faculty and academic heads:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-600">
                  <div className="p-3 bg-slate-50 rounded-lg">
                    <strong className="block text-gray-900 mb-1">Smart Timetables</strong>
                    Automated class scheduling, subject mapping, and faculty workload balance.
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg">
                    <strong className="block text-gray-900 mb-1">Marks & Assessment</strong>
                    Marksheet processing, automated GPA/CGPA computation, and progress tracking.
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg">
                    <strong className="block text-gray-900 mb-1">Role-Based Access</strong>
                    Dedicated portals for administrators, faculty, students, and parents.
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Key Metrics */}
          <section className="px-6 sm:px-12 py-10 border-b border-gray-100 bg-slate-900 text-white">
            <div className="text-center mb-8">
              <h2 className="text-xs font-bold text-indigo-400 tracking-wider uppercase mb-2">Key Benchmarks</h2>
              <h3 className="text-2xl font-bold text-white">Target Operational Impact</h3>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
              <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
                <div className="text-3xl font-extrabold text-indigo-400">1,000+</div>
                <div className="text-xs text-slate-300 mt-1 font-medium">Target Institutions</div>
              </div>
              <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
                <div className="text-3xl font-extrabold text-indigo-400">70%</div>
                <div className="text-xs text-slate-300 mt-1 font-medium">Cost Savings</div>
              </div>
              <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
                <div className="text-3xl font-extrabold text-indigo-400">0</div>
                <div className="text-xs text-slate-300 mt-1 font-medium">Server Maintenance</div>
              </div>
              <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
                <div className="text-3xl font-extrabold text-indigo-400">100%</div>
                <div className="text-xs text-slate-300 mt-1 font-medium">Cloud Architecture</div>
              </div>
            </div>
          </section>

          {/* Legal & Statutory Information */}
          <section className="px-6 sm:px-12 py-10 bg-slate-50 border-b border-gray-100">
            <h2 className="text-xs font-bold text-indigo-600 tracking-wider uppercase mb-2">Corporate Governance</h2>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Statutory & Registered Details</h3>

            <div className="bg-white p-6 rounded-xl border border-gray-200 text-sm text-gray-600 space-y-4 shadow-xs">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 pb-3 border-b border-gray-100">
                <span className="font-semibold text-gray-900">Legal Name</span>
                <span className="sm:col-span-2 text-gray-800">TRUYON TECHNOLOGIES (OPC) PVT LTD</span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 pb-3 border-b border-gray-100">
                <span className="font-semibold text-gray-900">Corporate Identification Number (CIN)</span>
                <span className="sm:col-span-2 font-mono text-gray-800 bg-gray-100 px-2.5 py-1 rounded w-fit text-xs font-medium">
                  U62013KA2026OPC221006
                </span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                <span className="font-semibold text-gray-900">Registered Office</span>
                <span className="sm:col-span-2 text-gray-700 leading-relaxed">
                  Unit 101, Oxford Towers, 139/88, HAL Old Airport Rd, H.A.L II Stage, Bangalore North, Bangalore, Karnataka, India, 560008.
                </span>
              </div>
            </div>
          </section>

          {/* Footer */}
          <footer className="px-6 sm:px-12 py-6 bg-white">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-gray-500">
              <span>© {new Date().getFullYear()} TRUYON TECHNOLOGIES (OPC) PVT LTD. All rights reserved.</span>
              <div className="flex flex-wrap gap-5 font-medium">
                <Link to="/terms-of-service" className="hover:text-indigo-600 transition-colors">Terms</Link>
                <Link to="/privacy-policy" className="hover:text-indigo-600 transition-colors">Privacy</Link>
                <Link to="/refund-policy" className="hover:text-indigo-600 transition-colors">Refund</Link>
                <Link to="/contact-us" className="hover:text-indigo-600 transition-colors">Contact</Link>
              </div>
            </div>
          </footer>

        </div>
      </main>
    </div>
  );
};

export default AboutUs;